import React from 'react'
import Typography, { TypographyProps } from '@material-ui/core/Typography'

interface IH4Prop {
  children: string
}
export const H4 = ({ children, ...props }: TypographyProps & IH4Prop) => (
  <Typography variant="h4" {...props}>
    {children}
  </Typography>
)
